module.exports = __webpack_public_path__ + "fonts/montserrat-thin-webfont.eb6956b.woff2";